'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

require('antd/lib/auto-complete/style/css');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoComplete = (0, _component2.default)(function () {
    return import("antd/lib/auto-complete");
});

var IDAutoComplete = function (_BaseComponent) {
    (0, _inherits3.default)(IDAutoComplete, _BaseComponent);

    function IDAutoComplete(props) {
        (0, _classCallCheck3.default)(this, IDAutoComplete);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IDAutoComplete.__proto__ || (0, _getPrototypeOf2.default)(IDAutoComplete)).call(this, props));

        _this.convertOptions = function (options) {
            var _this$props = _this.props,
                valueKey = _this$props.valueKey,
                labelKey = _this$props.labelKey;

            if (valueKey && valueKey !== 'value' || labelKey && labelKey !== 'label') {
                _lodash2.default.each(_this.props.options, function (option) {
                    if (valueKey) {
                        option.value = option[valueKey];
                    }
                    if (labelKey) {
                        option.label = option[labelKey];
                    }
                });
            }
            return options;
        };

        _this.handleChange = function (value) {
            var _this$props2 = _this.props,
                disabled = _this$props2.disabled,
                readOnly = _this$props2.readOnly;

            if (disabled || readOnly) {
                return;
            }
            _this.setValue(value);
        };

        _this.onSearch = function (value) {
            var optionsRaw = _this.state.optionsRaw;
            var valueKey = _this.props.valueKey;

            var options = [];
            if (value) {
                if (_this.props.onSearch) {
                    options = _this.props.onSearch(value, optionsRaw);
                } else {
                    options = _lodash2.default.filter(optionsRaw, function (item) {
                        return _this.boDauTiengViet(_lodash2.default.get(item, 'value')).indexOf(_this.boDauTiengViet(value)) > -1;
                    });
                }
            }

            _this.setState({
                options: options
            });
        };

        _this.state = {
            isFocus: false,
            value: props.value,
            optionsRaw: _this.convertOptions(props.options),
            options: []
        };
        _this.dataTestID = 'auto-complete';
        _this.classNameDefault = "auto-complete";
        return _this;
    }

    (0, _createClass3.default)(IDAutoComplete, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var options = nextProps.options,
                value = nextProps.value;

            var diffValue = false;
            var diffOptions = false;

            if (this.compareValue(value)) {
                diffValue = true;
            }

            if (this.compareOptions(options, this.props.options)) {
                diffOptions = true;
            }
            if (diffOptions) {
                this.setState({
                    optionsRaw: this.convertOptions(nextProps.options),
                    value: diffValue ? value : this.props.value
                });
            } else if (diffValue) {
                this.setState({
                    value: value
                });
            }
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            var _state = this.state,
                value = _state.value,
                options = _state.options;

            return _react2.default.createElement(AutoComplete, (0, _extends3.default)({}, _lodash2.default.omit(this.props, ["placeholder"]), {
                'data-testid': this.getSubDataTestId('input'),
                iconType: this.props.iconType || _lodash2.default.get(_ConfigGlobal2.default, 'iconType.edit'),
                value: value,
                onChange: this.handleChange,
                onSearch: this.onSearch,
                options: options
            }));
        }
    }]);
    return IDAutoComplete;
}(_BaseComponent3.default);

exports.default = IDAutoComplete;


IDAutoComplete.defaultProps = {
    iconCls: '',
    iconType: "edit",
    isClearable: true,
    visibleIcon: true,
    disabled: false,
    iconAlign: 'after',
    valueKey: 'value'
};